import React from 'react';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Navigate, useLocation } from 'react-router-dom';
import { InteractionStatus } from "@azure/msal-browser";

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress } = useMsal();
    const location = useLocation();

    // Check if interaction is in progress
    if (inProgress !== InteractionStatus.None) {
        return <div style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#000',
            color: 'white'
        }}>Verificando autenticação...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
